<header
  class="flex lg:hidden items-center fixed z-10 top-0 start-0 end-0 shrink-0 bg-mono dark:bg-background h-(--header-height)"
  id="header"
>
  <div class="kt-container-fixed flex items-center justify-between flex-wrap gap-3">
    <a routerLink="/">
      <img alt="Frida" class="size-[34px]" src="assets/media/app/mini-logo-circle-success.svg" />
    </a>

    <button
      class="kt-btn kt-btn-icon kt-btn-dim hover:text-white -me-2"
      data-kt-drawer-toggle="#sidebar"
      aria-label="Open sidebar"
      type="button"
    >
      <i class="ki-filled ki-menu"></i>
    </button>
  </div>
</header>